import { render, staticRenderFns } from "./NumberActionItems.vue?vue&type=template&id=2f0daad9"
import script from "./NumberActionItems.vue?vue&type=script&lang=js"
export * from "./NumberActionItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports